export const jaMessages = {
  role: {
    ADMIN: '管理者',
    LEADER: 'リーダー',
    MANAGER: 'プロジェクトマネージャー',
    VIEWER_MEMBER: '一般メンバー',
    MEMBER: '稼働入力メンバー'
  },
  costPeriod: {
    MONTHLY: '月給',
    DAILY: '日給',
    HOURLY: '時給',
    null: ''
  },
  dayOfWeek: {
    Monday: '月曜日',
    Tuesday: '火曜日',
    Wednesday: '水曜日',
    Thursday: '木曜日',
    Friday: '金曜日',
    Saturday: '土曜日',
    Sunday: '日曜日'
  },
  stageManager: {
    title: '変更内容',
    discardAll: '変更を全て破棄',
    message: {
      notSaved: '変更はまだ保存されていません。',
      saveInstruction: '保存するためには、変更の意図を記入し、保存ボタンを押してください。'
    },
    placeholder: '変更理由・意図を記載',
    save: '保存',
    processing: '処理中...',
    error: 'データの更新に失敗しました。お手数ですが再度お試しください。'
  },
  customField: {
    STRING: '文字列',
    NUMBER: '数値',
    DATETIME: '日付',
    CHOSE_SINGLE: '単一選択',
    CHOSE_MULTIPLE: '複数選択'
  },
  stages: {
    icon: {
      attendance: 'edit_calendar',
      work_on_project: 'edit_calendar',
      project: 'description',
      user: 'people_alt',
      employment: 'people_alt',
      assign: 'format_list_bulleted',
      assign_plan: 'format_list_bulleted',
      volumed_assign: 'format_list_bulleted',
      volumed_assign_plan: 'format_list_bulleted',
      target_cost_other: 'attach_money',
      target_cost_other_actual: 'attach_money',
      department: 'settings',
      client: 'settings',
      partner: 'settings',
      job_title: 'settings',
      job_skill: 'settings',
      custom_field: 'settings',
      custom_field_choice: 'settings',
      holiday: 'settings',
      regular_holiday: 'settings',
      setting: 'settings'
    },
    table: {
      attendance: '勤怠管理',
      work_on_project: 'プロジェクト稼働',
      project: 'プロジェクト',
      project_to_department: '担当部署',
      project_to_user: '担当者',
      user: '人材',
      employment: '契約',
      department: '部署',
      assign: 'プロジェクト要員',
      assign_plan: 'アサイン情報',
      volumed_assign: '未定要員',
      volumed_assign_plan: '未定要員アサイン情報',
      volumed_assign_to_job_skill: '未定要員のスキル',
      volumed_assign_to_department: '未定要員の部署',
      target_cost_other: 'その他費用',
      target_cost_other_actual: 'その他費用実績',
      client: 'クライアント',
      partner: '委託先',
      job_title: '役割',
      job_skill: 'スキル',
      custom_field: 'カスタムフィールド',
      custom_field_choice: '選択オプション',
      holiday: '休日',
      regular_holiday: '休日の曜日',
      setting: 'システム設定'
    },
    actions: {
      delete: '削除',
      edit: '編集',
      create: '登録',
      order: '並び順'
    },
    labels: {
      attendance: { clocks: '稼働' },
      work_on_project: {
        actuals: '稼働時間',
        comments: 'コメント'
      },
      project: {
        name: 'プロジェクト名',
        code: 'プロジェクトコード',
        start_date: 'プロジェクト開始',
        end_date: 'プロジェクト終了',
        target_sales: '提案金額',
        client_id: 'クライアント',
        detail: '概要',
        custom_fields: 'カスタムフィールド',
        target_cost: '目標原価',
        target_man_month: '目標工数',
        target_man_hours_in_sec: '目標工数',
        userIds: '担当者',
        departmentIds: '担当部署',
        target_sales_breakdown_plan: '各月売上'
      },
      error: {
        required: '必須',
        invalidDate: '日付の形式が正しくありません。',
        max30Items: '30個以下にしてください',
        max30Users: '30人以下にしてください',
        max10Departments: '10部署以下にしてください',
        min2Chars: '2文字以上にしてください。',
        max128Chars: '128文字以下にしてください。',
        alphanumeric: '半角英数記号で入力してください',
        codeExists: 'そのコードはすでに使われています',
        endDateAfterStartDate: '終了日は開始日よりも未来にしてください。',
        within5Years: '開始日から終了日までの期間は5年以内にしてください。',
        workResultOutsidePeriod: '期間外に実績（稼働またはその他費用）が登録されています。',
        invalidItemIncluded: '無効な項目が含まれています',
        zod: {
          offsetNegative: '0以上の整数を入力してください。',
          endDateAfterStartDate: '終了日は開始日よりも未来にしてください。'
        },
        user: {
          nameTooLong: '32文字以下にしてください',
          nameTooShort: '2文字以上にしてください',
          emailTooLong: '128文字以下にしてください',
          invalidEmail: '正しいメールアドレスを入力してください',
          higherRole: '自分より高い権限は設定できません',
          noteTooLong: '5000文字以下にしてください',
          notInteger: '整数を入力してください',
          displayOrderNegative: '0以上の数値を入力してください',
          duplicateEmail: 'メールアドレスが重複しています',
          max10Department: '10個以下にしてください',
          max30JobTitle: '30個以下にしてください',
          max160JobSkill: '160個以下にしてください'
        },
        password: {
          minLength: '8文字以上にしてください',
          maxLength: '128文字以下にしてください',
          requiredTypes:
            '大文字、小文字、数字、記号({{symbol}})のうち、最低3つの文字タイプを入力してください。',
          mismatch: 'パスワードが一致していません。'
        },
        tenant: {
          formatError: '書式は HH:MM-HH:MM でお願いいたします',
          rangeError: '終了時間は開始時間より後にお願いいたします',
          breakRangeError: '休憩時間は勤務時間内でお願いいたします',
          dailyWorkTime: '00:01 - 23:59 の間でお願いいたします',
          thresholdLength: '閾値は4つの整数で指定してください',
          thresholdOrder: '閾値は昇順（小さい順）でお願いいたします',
          thresholdDuplicate: '閾値に重複があります'
        },
        employment: {
          invalidStartDate: '1980年から2099年まで入力できます',
          costMustBeInteger: '整数のみ入力できます',
          costNegative: '0以上にしてください',
          costTooLarge: '9,999,999以下にしてください',
          duplicateStartMonth: 'すでに設定されている開始月です。'
        }
      },
      user: {
        name: '名前',
        email: 'メール',
        role: 'システムロール',
        departmentIds: '部署',
        jobTitleIds: '役割',
        jobSkillIds: 'スキル',
        note: '備考',
        available: '有効/無効',
        display_order: '表示順'
      },
      employment: { start: '開始月', partner_id: '所属', type: '単価タイプ', cost: '単価金額' },
      assign: {
        visible: 'アサイン',
        comment: 'コメント',
        icon: 'アイコン',
        user_id: '人材'
      },
      assign_plan: {
        start_offset: '開始日',
        end_offset: '終了日',
        estimate: '稼働時間/日',
        plan_start_date: '開始日',
        plan_end_date: '終了日'
      },
      volumed_assign: {
        job_title_id: '役割',
        jobSkillIds: 'スキル',
        departmentIds: '部署',
        comment: 'コメント',
        icon: 'アイコン'
      },
      volumed_assign_plan: {
        start_offset: '開始日',
        end_offset: '終了日',
        estimate: '稼働時間/日',
        plan_start_date: '開始日',
        plan_end_date: '終了日'
      },
      volumed_assign_to_department: {
        department_id: '部署'
      },
      target_cost_other: { name: '費用名', costs_plan: '金額' },
      target_cost_other_actual: {
        name: '費用名',
        month: '月',
        cost: '実績金額',
        costs_actual: '実績金額'
      },
      department: { name: '部署名', order: '表示順' },
      client: { name: 'クライアント名', order: '表示順' },
      partner: { name: '委託先名', order: '表示順' },
      job_title: { name: '役割名', choosable: '有効/無効', order: '表示順' },
      job_skill: { name: 'スキル名', choosable: '有効/無効', order: '表示順' },
      custom_field: {
        name: '表示ラベル名',
        key: 'オブジェクト名',
        description: '説明',
        value_type: 'データ型',
        required: '必須項目',
        visible: '有効/無効'
      },
      custom_field_choice: {
        name: '名前',
        key: 'オブジェクト名',
        visible: '有効/無効',
        order: '表示順'
      },
      holiday: { name: '休日名', date: '日付' },
      regular_holiday: { year: '年', day_of_week: '曜日', day_off: '休日設定' },
      setting: { settings: '設定' }
    }
  },
  changeType: {
    insert: '追加',
    update: '更新',
    delete: '削除',
    maintenance_insert: 'システムにより追加',
    maintenance_update: 'システムにより更新',
    maintenance_delete: 'システムにより削除'
  },
  changeTypeIcon: {
    insert: 'add_circle',
    update: 'cached',
    delete: 'delete',
    maintenance_insert: 'settings',
    maintenance_update: 'settings',
    maintenance_delete: 'settings'
  },
  ui: {
    chart: {
      planned: '計画',
      actual: '実績',
      noData: 'データなし'
    },
    unsavedChanges: '保存されていない変更があります',
    delete: '削除',
    cancel: 'キャンセル',
    addProject: {
      title: '{{name}} のプロジェクトをアサインする',
      roleLabel: '役割'
    },
    error: {
      parentIsRemoved: '親項目が削除されています'
    },
    common: {
      add: '追加',
      cancel: 'キャンセル',
      count: '件',
      month: '月',
      previousMonth: '前月',
      nextMonth: '翌月',
      manMonth: '人月',
      manDay: '人日',
      hour: '時間',
      plan: '計画',
      actual: '実績',
      department: '部署',
      undefinedDepartment: '部署未設定',
      undefinedResource: '未定要員',
      download: 'ダウンロード',
      undefined: '未定',
      assignStatus: 'アサイン状況',
      assignStatusLabel: {
        unplanned: '計画なし',
        existVolumed: '未定要員あり',
        assigned: 'アサイン済み'
      },
      all: 'すべて',
      unknown: '不明',
      inputting: '入力中...',
      invalid: '無効',
      reload: 'リロード',
      relogin: '再ログイン',
      ownCompany: '自社',
      others: 'その他',
      copy: 'コピー',
      copying: 'コピー中...',
      loading: '読み込み中...',
      readMore: 'もっと見る',
      fold: '折りたたむ',
      wordJoiner: 'を',
      total: '合計',
      edit: '編集',
      dragOrder: '順番入れ替え',
      reset: 'リセット',
      projectName: 'プロジェクト名',
      projectCode: 'プロジェクトコード',
      period: '期間',
      client: 'クライアント',
      description: '概要',
      createdAt: '登録日',
      updatedAt: '更新日',
      active: '有効',
      inactive: '無効',
      status: '有効/無効',
      operation: '操作',
      date: '日付',
      name: '名前',
      note: '備考',
      year: '年',
      delete: '削除',
      asc: '昇順',
      desc: '降順',
      startDate: '開始日',
      endDate: '終了日',
      fixError: 'エラーを修正してください',
      noDepartment: '所属部署未登録',
      rangeSeparator: '〜',
      workType: 'アサイン種別',
      namedResource: '人材',
      volumedResource: '未定要員'
    },
    router: {
      appTitle: 'アサイン管理ツール',
      login: 'ログイン',
      logout: 'ログアウト',
      forbidden: '権限エラー',
      notFound: 'ページが見つかりません'
    },
    workerStatus: {
      initializingTitle: '準備中',
      initializingMessage: 'データの準備中です。少々お待ちください。',
      systemTerminatedTitle: 'システム終了',
      systemErrorMessage: '操作を続けるためには再ログインをしてください。',
      systemErrorTitle: 'システムエラー',
      unknownTitle: 'しばらくお待ちください',
      unknownMessage: 'しばらく待っても解消しない場合はお問合せください。'
    },
    clientDelete: 'クライアントの削除',
    targetClient: '削除するクライアント',
    clientName: 'クライアント名',
    warning: {
      cannotRestore: '・削除したマスタは元に戻せません',
      cannotDeleteUsed: '・利用中のマスタは削除できません。紐付けを解除し、登録後に削除してください'
    },
    sideMenu: {
      resource: 'リソース管理',
      userProject: '人材 x プロジェクト',
      projectUser: 'プロジェクト x 人材',
      attendance: '稼働管理',
      dataReport: 'データ・レポート',
      settings: '設定',
      partner: '所属',
      changePassword: 'パスワード変更',
      logout: 'ログアウト',
      collapse: 'サイドバーを狭める',
      expand: 'サイドバーを広げる'
    },
    resetPreferences: {
      title: '設定 > 設定のリセット',
      warning: 'すべての設定をリセットします。',
      warningBold: 'この操作は取り消せません。',
      success: '設定をリセットしました。',
      backHome: 'ホームへ戻る'
    },
    forbiddenView: {
      title: 'アクセスが拒否されました',
      message: 'このページを表示する権限がありません。',
      contact: '権限が必要な場合は管理者にお問い合わせください。',
      backHome: '今すぐホームに戻る'
    },
    userList: {
      assignable: 'アサイン対象',
      target: '対象',
      notTarget: '対象外',
      add: '人材を追加',
      assignableTooltip: '役割が設定されているとアサイン対象'
    },

    controlPanel: {
      filter: 'フィルタ',
      group: 'グループ',
      applied: '適用中'
    },
    user: {
      display_order: '表示順',
      name: '名前',
      email: 'メールアドレス',
      role: 'システムロール'
    },
    userEdit: {
      titleNew: '人材を作成',
      titleEdit: '人材を変更',
      changeSecurity: 'セキュリティ設定の変更',
      forcePasswordChange: 'パスワードを強制変更',
      resetMFA: '多要素認証のリセット',
      systemRoleTooltip1:
        'Co-Assignのシステム上の権限設定となり社内の役職名とは異なるのでご注意ください。',
      systemRoleTooltip2:
        'システムロールで操作できる機能が異なります。<br />詳細は右部：人材の設定＞システムロールのマニュアルをご確認ください。',
      displayOrderTooltip:
        '数値で指定（連番でなくても可）。<br />未入力の場合は0として扱われ、先頭に表示されます。複数の人材でまとめて指定する場合は、人材インポートをご活用ください。',
      availableHelp: 'チェックを外した場合、無効となり新たにアサインができなくなります。',
      available: '有効',
      assignableRole: '担当可能な役割'
    },
    employmentList: {
      unitPrice: '単価',
      unitPriceTooltip: '設定するとプロジェクトの原価が計算できるようになります。',
      addUnitPrice: '単価を追加',
      startMonth: '開始月',
      affiliation: '所属',
      unitPriceType: '単価タイプ',
      emptyState: '人材登録後に設定可能です'
    },
    clientEdit: {
      create: 'クライアントを作成',
      edit: 'クライアントを変更',
      nameLabel: 'クライアント'
    },
    projectSummary: {
      headers: {
        target: '目標',
        plan: '計画',
        actual: '実績'
      },
      rows: {
        sales: '売上',
        cost: '原価',
        profit: '粗利',
        profitRate: '粗利率'
      },
      units: {
        monthly: '人月',
        daily: '人日',
        hourly: '人時'
      },
      currency: '円'
    },
    changePassword: {
      newPassword: '新しいパスワード',
      change: 'パスワードを変更する',
      success: 'パスワードを変更しました。',
      fail: 'パスワードの変更に失敗しました。',
      title: 'パスワード変更',
      currentPassword: '現在のパスワード',
      newPasswordConf: '変更後のパスワード（確認）',
      newPasswordConfirm: '新しいパスワード（確認）',
      submit: 'パスワード変更する',
      messages: {
        success: 'パスワードを更新しました。',
        failure: 'パスワードを更新できませんでした。',
        mismatch: '現在のパスワードが一致しません',
        disabled: 'お使いのテナントではパスワード変更ができません。'
      }
    },
    resetPassword: {
      newPassword: '新しいパスワード',
      newPasswordConf: '新しいパスワード（確認）',
      change: 'パスワードを変更する',
      success: 'パスワードが変更されました。',
      successMessage: 'パスワードの再設定が完了しました。',
      fail: 'パスワードの更新に失敗しました。再度パスワードの再設定をお試しください。',
      invalidCode: '無効または期限切れのコードです。再度パスワードの再設定をお試しください。',
      loginLink: 'ログイン画面に戻る'
    },
    settingEdit: {
      title: '設定 > システム設定',
      info: 'システム全体の設定を行います。設定内容は即時反映されますのでご注意ください。'
    },
    holidayList: {
      title: '設定 > 休日',
      regularHoliday: '所定休日・法定休日',
      specifiedList: {
        title: '国民の祝日・年末年始・会社固有の祝日',
        loadBasic: '標準の休日を読み込む',
        add: '休日を追加'
      },

      weekdays: {
        mon: '月',
        tue: '火',
        wed: '水',
        thu: '木',
        fri: '金',
        sat: '土',
        sun: '日'
      }
    },
    departmentList: {
      title: '設定 > 部署',
      add: '部署を追加',
      headers: {
        department: '部署',
        userCount: 'ユーザー数',
        projectCount: 'プロジェクト数',
        operation: '操作'
      }
    },
    clientList: {
      title: '設定 > クライアント',
      add: 'クライアントを追加',
      headers: {
        client: 'クライアント',
        projectCount: 'プロジェクト数',
        operation: '操作'
      }
    },
    projectSalesAndCost: {
      title: 'プロジェクト > 収支計画',
      pva: '予実',
      sales: '売上',
      cost: '原価',
      manCost: '人件費',
      otherCost: '費用',
      otherCosts: '費用の登録',
      addOtherCost: '費用を追加',
      manCostPva: '人材ごとの予実',
      resourcePlan: '要員計画',
      salesDistribution: {
        auto: '月で按分',
        manual: '個別に入力'
      },
      projectInfo: {
        code: 'プロジェクトコード',
        period: '期間',
        department: '担当部署',
        manager: '担当者'
      },
      profit: '粗利',
      profitRate: '粗利率(%)',
      plan: '計画',
      actual: '実績',
      otherCostDelete: {
        title: '費用の削除',
        deleteTarget: '削除する費用',
        costName: '費用名',
        deleteWithActualWarning:
          'この項目には実績値が登録されています。削除すると実績値も全て削除されます。',
        deleteWithoutActualWarning: '削除した費用は元に戻せません'
      }
    },
    projectUser: {
      title: 'リソース計画 > プロジェクト × 人材',
      group: 'グループ',
      groups: {
        none: 'なし',
        department: '担当部署',
        assignStatus: 'アサイン状況',
        client: 'クライアント'
      },
      unspecified: '未指定',
      totalUserCount: '人数',
      totalOperationRate: {
        planRate: '計画稼働率',
        planEffortTotal: '計画工数合計',
        filtered: '(フィルタ後)',
        remaining: '残り',
        show: '表示する',
        calculateTooltip:
          '人数が多く計算に時間がかかるため保留状態となっています。クリックすると計算されます。'
      }
    },
    jobSkillList: {
      title: '設定 > スキル',
      add: 'スキルを追加',
      headers: {
        jobSkill: 'スキル',
        userCount: 'ユーザー数',
        projectCount: 'プロジェクト数',
        status: '有効/無効',
        operation: '操作'
      },
      active: '有効',
      inactive: '無効'
    },
    jobSkillDelete: {
      title: 'スキルの削除',
      targetJobSkill: '削除するスキル',
      jobSkillName: 'スキル名',
      warning: {
        cannotRestore: '・削除したマスタは元に戻せません',
        cannotDeleteUsed:
          '・利用中のマスタは削除できません。紐付けを解除し、登録後に削除してください'
      }
    },
    jobSkillEdit: {
      create: 'スキルを作成',
      edit: 'スキルを変更',
      nameLabel: 'スキル',
      availableLabel: '有効/無効',
      availableDescription: 'チェックを外した場合、無効となり選択ができなくなります。',
      active: '有効'
    },
    departmentEdit: {
      create: '部署を作成',
      edit: '部署を変更',
      nameLabel: '部署'
    },
    departmentDelete: {
      title: '部署の削除',
      targetDepartment: '削除する部署',
      departmentName: '部署名',
      warning: {
        cannotRestore: '・削除したマスタは元に戻せません',
        cannotDeleteUsed:
          '・利用中のマスタは削除できません。紐付けを解除し、登録後に削除してください'
      }
    },
    partnerEdit: {
      create: '所属を作成',
      edit: '所属を変更',
      nameLabel: '所属先'
    },
    partnerList: {
      title: '設定 > 所属',
      add: '所属を追加',
      headers: {
        partner: '所属',
        userCount: 'ユーザー数',
        operation: '操作'
      }
    },
    partnerDelete: {
      title: '所属の削除',
      targetPartner: '削除する所属',
      partnerName: '所属名',
      warning: {
        cannotRestore: '・削除したマスタは元に戻せません',
        cannotDeleteUsed: '・プロジェクトで利用されているマスタは削除できません。'
      }
    },
    customFieldList: {
      title: '設定 > カスタムフィールド',
      tips: 'カスタムフィールドを設定すると、プロジェクトに独自の項目を追加することができます。',
      add: 'カスタムフィールドを追加',
      headers: {
        name: '表示ラベル',
        key: 'オブジェクト名',
        valueType: 'データ型',
        description: '説明',
        required: '必須オプション',
        visible: '有効/無効',
        operation: '操作'
      },
      placeholders: {
        search: '表示ラベル / オブジェクト名'
      }
    },
    customFieldChoice: {
      label: '選択肢',
      description: '「単一選択」「複数選択」の選択肢を設定できます。',
      add: '選択肢を追加',
      headers: {
        name: '名前',
        key: 'オブジェクト名',
        visible: '有効/無効',
        operation: '操作'
      },
      active: '有効'
    },
    customFieldEdit: {
      create: 'カスタムフィールドを作成',
      edit: 'カスタムフィールドを変更',
      nameLabel: '表示ラベル',
      keyLabel: 'オブジェクト名',
      keyDescription: '登録すると変更はできません。',
      typeLabel: 'データ型',
      addChoiceDescription: '選択肢を追加してください。',
      descriptionLabel: '説明',
      requiredLabel: '必須オプション',
      requiredDescription: 'チェックを外した場合、任意の入力項目になります。',
      required: '必須',
      optional: '任意',
      visibleLabel: '有効/無効',
      visibleDescription: 'チェックを外した場合、プロジェクトに表示されなくなります。',
      visible: '有効'
    },
    jobTitleList: {
      title: '設定 > 役割',
      add: '役割を追加',
      headers: {
        jobTitle: '役割',
        userCount: 'ユーザー数',
        projectCount: 'プロジェクト数',
        status: '有効/無効',
        operation: '操作'
      },
      active: '有効',
      inactive: '無効'
    },
    jobTitleDelete: {
      title: '役割の削除',
      targetJobTitle: '削除する役割',
      jobTitleName: '役割名'
    },
    jobTitleEdit: {
      create: '役割を作成',
      edit: '役割を変更',
      nameLabel: '役割',
      nameWarning:
        '役割名は役職、等級を含めないものにしてください。詳細は「記入例」を参照してください。',
      availableLabel: '有効/無効',
      availableDescription: 'チェックを外した場合、無効となり選択ができなくなります。',
      active: '有効'
    },
    projectList: {
      title: 'プロジェクト',
      columnSettings: '列の表示設定',
      add: 'プロジェクトを追加',
      assignStatusTooltip: {
        noPlan: '・計画なし：人材/未定要員のアサインが存在しない',
        hasTbd: '・未定要員あり：未定要員のアサインが１つ以上存在する',
        assigned: '・アサイン済み：人材のアサインのみ存在する'
      },
      salesAndCostPlan: '収支計画',
      sort: {
        targetSales: '提案金額(円)',
        targetCost: '目標原価(円)',
        targetManMonth: '目標工数(人月)'
      }
    },
    projectDelete: {
      title: 'プロジェクトの削除',
      targetProject: '削除するプロジェクト',
      projectName: 'プロジェクト名',
      warning: {
        cannotRestore: '削除したプロジェクトは元に戻せません',
        hasWorkResult:
          'プロジェクトに稼働実績が入力されています。プロジェクトを削除するには、稼働実績をクリアしてください。',
        hasOtherCostActual:
          'プロジェクトにその他費用の実績が入力されています。プロジェクトを削除するには、その他費用の実績をクリアしてください。',
        cannotRestoreProject: '削除したプロジェクトは元に戻せません'
      }
    },
    projectCopy: {
      title: 'プロジェクトのコピー',
      description:
        'アサイン情報もコピーされます。※稼働実績と無効の人材のアサインはコピーされません。',
      targetProject: 'コピーするプロジェクト',
      projectName: 'プロジェクト名',
      execute: 'プロジェクトをコピーする',
      copying: 'コピー中...',
      goToSource: 'コピー元のプロジェクトに移動する',
      error:
        'プロジェクトに入力エラーがあるためコピーを中止しました。コピー元のプロジェクトを確認してください。もしくは、重複するプロジェクトコードのデータが存在します。'
    },
    projectInfoPanel: {
      projectCode: 'プロジェクトコード',
      department: '担当部署',
      assignedUser: '担当者',
      period: '期間',
      createdAt: '登録日',
      updatedAt: '更新日',
      overview: '概要'
    },
    searchChipsDisplay: {
      details: '詳細',
      clear: 'クリア',
      noDepartment: '所属部署未登録'
    },
    noDataText: {
      message: '表示するデータがありません。',
      suggestion: '検索条件を変更するか、「{{action}}」 することもできます。',
      simpleSuggestion: '「{{action}}」 できます。'
    },
    noSetting: {
      message: '設定がありません。'
    },
    noHoliday: {
      message: '休日が登録されていません。'
    },
    searchBox: {
      projectCode: 'プロジェクトコード',
      projectName: 'プロジェクト名',
      department: '部署',
      manager: '担当者',
      managerOrDepartment: '担当者・担当部署',
      deptUser: '部署・人材',
      assignedUser: '人材',
      jobTitle: '役割',
      skill: 'スキル',
      endDate: '終了日',
      createdAt: '登録日',
      updatedAt: '更新日',
      projectPeriod: '次の期間中に稼働',
      assignStatus: 'アサイン状況',
      keyword: 'キーワード',
      projectStart: 'プロジェクト開始日',
      projectEnd: 'プロジェクト終了日',
      client: 'クライアント',
      name: '名前',
      email: 'メールアドレス',
      systemRole: 'システムロール',
      status: {
        unplanned: '計画なし',
        existVolumed: '未定要員あり',
        assigned: 'アサイン済み'
      },
      availableLabel: '有効/無効',
      available: '有効',
      unavailable: '無効',
      search: '検索',
      filterPlaceholder: '人材を絞り込む',
      clear: 'クリア',
      advancedSearch: '詳細検索',
      bothRequired: 'アサイン種別と役割の両方を選択してください'
    },
    assignColumn: {
      deleted: '(削除)',
      invalid: '(無効)',
      daySuffix: '日',
      addResource: '人材を追加',
      addTbdResource: '未定要員を追加',
      tooltip: {
        operation: '操作',
        deleteAssign: 'アサインを削除',
        editAssign: 'アサインを変更',
        close: '閉じる',
        deleteWarning: '稼働が登録されているため削除することができません。',
        editWarning: '稼働が登録されているため変更することができません。'
      },
      modal: {
        assignPeriod: 'アサイン期間',
        fromTo: '〜',
        workTimePerDay: '稼働時間 /日',
        minutesPerDay: '分/日',
        hoursPerDay: '時間/日',
        workTimeRatio: '稼働時間/割合',
        percentPerDay: '％/日',
        workTimeTotal: '稼働時間/合計',
        hoursPerPeriod: '時間/アサイン期間({{days}}日間)',
        manDaysPerPeriod: '人日/アサイン期間({{days}}日間)',
        manMonthsPerPeriod: '人月/アサイン期間({{days}}日間)',
        manMonthDescription: '1人月は20営業日固定で計算されます。',
        close: '閉じる',
        delete: '削除',
        tbd: '未定'
      }
    },
    home: {
      updateInfo: 'アップデート情報',
      manuals: '各種マニュアル',
      announcements: 'お知らせ'
    },
    jobTrigger: {
      title: 'Job Trigger 管理',
      subtitle: 'Job Trigger テーブル管理（開発者用）',
      warning: 'これは開発者専用ページです。データの変更は慎重に行ってください。',
      description: 'Job Trigger テーブルのデータを管理します。',
      listDescription: {
        view: 'Job Trigger の一覧表示',
        create: '新規 Job Trigger の作成',
        edit: '既存 Job Trigger の編集',
        delete: 'Job Trigger の削除（論理削除）'
      },
      reload: 'データを再読み込み',
      jobId: 'Job ID',
      triggerType: 'Trigger Type',
      selectPlaceholder: '-- 選択してください --',
      timing: 'Timing',
      timingPlaceholder: {
        periodic: '例: 0 0 * * * (cron式)',
        email: 'メール設定（オプション）',
        default: '実行タイミングを入力'
      },
      cronExamplePrefix: 'Cron式の例:',
      cronExamples: {
        daily: '毎日0時',
        every5min: '5分ごと',
        weekdays: '平日9時'
      },
      emailDescription: 'メール受信タイミングの設定（オプション）',
      triggerTypePeriodicWarning:
        '※ Timingフィールドにcron式を入力してください（例: 0 0 * * * - 毎日0時）',
      triggerTypeEmailWarning: '※ メール受信時に自動実行されます',
      params: 'Params (JSON)',
      paramSchema: 'パラメータスキーマ',
      formatJson: 'JSONを整形',
      claim: 'Claim (JSON)',
      defaultJson: 'デフォルト: {}',
      listTitle: 'Job Trigger 一覧',
      headers: {
        id: 'ID',
        jobId: 'Job ID',
        jobName: 'Job名',
        triggerType: 'Trigger Type',
        timing: 'Timing',
        params: 'Params',
        claim: 'Claim',
        createdAt: 'Created At',
        operation: '操作'
      },
      messages: {
        loadError: 'データの読み込みに失敗しました',
        saveError: '保存に失敗しました',
        deleteError: '削除に失敗しました',
        validationError: 'バリデーションエラー',
        jsonError: 'JSONの形式が正しくありません',
        confirmDelete: 'このJob Triggerを削除しますか？（論理削除）'
      }
    },
    addNamedAssign: {
      title: 'バイネームの要員を追加',
      selectUser: '追加する人材をチェックしてください。',
      selectUserForTbd: '未定要員に割り当てる人材をチェックしてください。',
      filterPlaceholder: '人材が所属する部署、または人材で絞り込む',
      projectPeriod: 'プロジェクト期間：',
      noDepartment: '所属部署未登録'
    },
    addVolumedAssign: {
      title: '未定要員を追加',
      description: '追加する役割とスキル（任意）を選択してください',
      addMore: '未定要員を追加で登録する'
    },
    projectHistory: {
      dateLimit: '※2025年06月30日以前の履歴は表示されません。',
      noHistory: '変更履歴はありません。',
      systemUpdate: 'システムによる更新',
      systemUpdateTooltip:
        'プロジェクト期間の変更や保守対応などにより、関連データの整合性を保つため、自動で更新される場合があります。',
      unknownData: '不明なデータ',
      deletedData: '削除されたデータ',
      unknownIcon: '不明なアイコン',
      noData: 'なし',
      hoursPerDay: '時間/日',
      manMonth: '人月',
      currency: '円'
    },

    jobList: {
      title: 'データ・レポート',
      exportMessages: {
        workResultExported: '{{count}}件の稼働実績をエクスポートしました。'
      },
      jobs: {
        カスタムレポート: {
          name: 'カスタムレポート',
          description:
            'プロジェクトごとに関連するユーザー情報(ユーザー名、mail、人月)を一行で横展開された情報をCSV形式でダウンロードすることができます。'
        },
        'リソースレポート（Ver2）': {
          name: 'リソースレポート（Ver2）',
          description:
            '指定した期間の月ごとのリソース状況（プロジェクト・人材ごとの計画と実績）をダウンロードできます。'
        },
        'リソースレポート（旧版・26年3月末提供終了予定）': {
          name: 'リソースレポート（旧版・26年3月末提供終了予定）',
          description:
            '指定した期間の月ごとのリソース状況（プロジェクト・人材ごとの計画と実績）をダウンロードできます。旧版は26年3月末に提供終了予定のため、Ver2への切り替えをお願いいたします。Ver2で出力されるデータは変りません（一部シートでカラムの表示順の変更あり）。パフォーマンス向上のため「結合_参照」シートの関数配列を廃止し、通常のセル参照に変更しました。'
        },
        プロジェクトインポート: {
          name: 'プロジェクトインポート',
          description: 'CSV形式でプロジェクトデータをアップロードし追加・更新します。',
          params: {
            file: 'CSVファイルの選択'
          }
        },
        プロジェクトエクスポート: {
          name: 'プロジェクトエクスポート',
          description:
            'プロジェクトの終了日が過去2年より新しいプロジェクトの一覧をCSV形式でダウンロードすることができます。'
        },
        人材インポート: {
          name: '人材インポート',
          description: 'CSV形式で人材をアップロードし追加・更新します。',
          params: {
            file: 'CSVファイルの選択'
          }
        },
        人材エクスポート: {
          name: '人材エクスポート',
          description: 'CSV形式で人材データをダウンロードします。'
        },
        稼働実績インポート: {
          name: '稼働実績インポート',
          description: 'CSV形式で稼働実績をアップロードし追加・更新します。',
          params: {
            file: 'CSVファイルの選択',
            target_month: '取込月'
          }
        },
        稼働実績エクスポート: {
          name: '稼働実績エクスポート',
          description: '指定した月の稼働実績をダウンロードすることができます。',
          params: {
            file: 'Select CSV File',
            target_month: '対象月'
          }
        }
      }
    },
    workSheet: {
      title: '稼働管理 > 勤務表',
      table: {
        date: '日付',
        start: '出勤',
        end: '退勤',
        break: '休憩時間',
        workTime: '労働時間',
        total: '稼働合計',
        input: '入力',
        project: 'プロジェクト',
        workTimeSummary: '稼働時間'
      },
      edit: '編集',
      inputError: '入力エラーがあります。修正をしてください。',
      noInput: '{{month}}月の稼働実績の入力はされていません',
      totalWorkTime: '労働時間合計',
      totalActual: '稼働合計'
    },
    workEdit: {
      title: '稼働入力',
      workTime: '勤務時間',
      breakTime: '休憩時間',
      copyFromSpecificDay: '指定日からコピー',
      filter: {
        search: '検索',
        clear: 'クリア',
        none: 'なし',
        entered: '稼働入力済み',
        notEntered: '稼働未入力',
        latest7: {
          label: '直近7日間',
          description: '直近7日間に稼働時間を更新したプロジェクトのみ表示します'
        },
        latest30: {
          label: '直近30日間',
          description: '直近30日間に稼働時間を更新したプロジェクトのみ表示します'
        }
      },
      table: {
        projectName: 'プロジェクト名',
        projectCode: 'プロジェクトコード',
        role: '役割',
        comment: 'コメント',
        actualTime: '稼働時間',
        planTime: '計画工数',
        monthTime: '当月工数',
        copyPlanTime: '計画工数の時間をコピー',
        empty:
          '表示するデータがありません。<br />検索条件を変更するか、プロジェクトにアサインされているかご確認ください。'
      },
      info: {
        formula: '労働時間 - 稼働時間 = {{label}}',
        unenteredTime: '未入力時間',
        exceededTime: '超過時間',
        workTime: '労働時間：',
        actualTime: '稼働時間：',
        unenteredTimeLabel: '未入力時間：',
        exceededTimeLabel: '超過時間：',
        unmatchedTotal: '労働時間と稼働時間の合計が一致しません'
      },
      copyModal: {
        title: '指定日の勤務時間/稼働時間のコピー',
        notice:
          '・現在入力されている勤務時間 / 稼働時間は上書きされます。<br />・期間外のプロジェクトの稼働時間はコピーされません。',
        sourceDay: '指定日：',
        copy: '勤務/稼働をコピーする',
        errorNoSource: 'コピー元の日付が選択されていません'
      }
    },

    displayPeriod: {
      unit: {
        monthly: '月次',
        monthlySmall: '月次(細)',
        weekly: '週次',
        daily: '日次'
      },
      amount: {
        twoWeeks: '2週間',
        eightWeeks: '8週間',
        nineWeeks: '9週間',
        twelveWeeks: '12週間',
        sixteenWeeks: '16週間',
        oneMonth: '1ヶ月',
        twoMonths: '2ヶ月',
        sixMonths: '6ヶ月',
        nineMonths: '9ヶ月',
        twelveMonths: '12ヶ月',
        twentyFourMonths: '24ヶ月'
      }
    },
    resourcePlan: {
      title: '要員計画',
      userProjectTitle: 'リソース計画 > 人材 × プロジェクト',
      summary: '収支サマリー',
      salesCost: '収支計画',
      chart: {
        monthly: '単月・工数',
        accumulation: '累計・工数'
      },

      unit: {
        monthly: '人月',
        daily: '人日',
        hourly: '人時'
      },
      addMember: '人材を追加',
      addPendingMember: '未定要員を追加',
      undefinedStaff: '未定要員',
      undefinedJobTitle: '役割未定',
      noDepartment: '部署未設定',
      close: '閉じる'
    },
    otherCost: {
      createTitle: '費用を作成',
      editTitle: '費用を変更',
      name: '費用名',
      newCost: '新規費用',
      total: '合計',
      currency: '円',
      syncWithPlan: '実績値を予定と同額にする',
      plan: '計画'
    },
    projectEdit: {
      createTitle: 'プロジェクトを作成',
      editTitle: 'プロジェクトを変更',
      name: 'プロジェクト名',
      period: 'プロジェクト期間',
      code: 'プロジェクトコード',
      client: 'クライアント',
      description: '概要',
      costManagement: '原価管理',
      costManagementDesc: '要員計画で原価率が計算できるようになります。',
      targetSales: '提案金額',
      targetCost: '目標原価',
      targetManHours: '目標工数',
      currency: '円',
      manMonth: '人月',
      member: '担当',
      memberDesc: '設定された人材はプロジェクトの変更が可能です',
      department: '部署',
      invalidItemIncluded: '存在しない項目が含まれています'
    },
    planActualMode: {
      plan: '計画',
      actual: '実績'
    },
    jobDetail: {
      manual: 'マニュアル',
      unsavedJobWarning:
        'このジョブはまだ保存されていないため、実行することができません。実行するためには、保存をしてください。',
      execute: '実行',
      executedMessage: '実行しました。ジョブの実行結果が下に表示されます。',
      error: {
        invalidFile: '不正なファイルが選択されました。',
        general: 'エラーが発生しました。',
        fileReadFail: 'ファイルの読み込みに失敗しました'
      }
    },
    resetMFA: {
      title: '多要素認証のリセット',
      description1: '選択したユーザについて、多要素認証をリセットします。',
      description2: 'リセット後、再度ログイン時に多要素認証の登録が求められます。',
      reset: '多要素認証をリセットする',
      success: '多要素認証をリセットしました。',
      fail: '失敗しました。再度お試しください。'
    },
    customFieldNames: {
      order_probability: '受注確度'
    },
    dashboard: {
      title: '人材ダッシュボード',
      userInfo: '人材情報',
      workStatus: '稼働状況',
      performanceDetails: '実績詳細',
      assignmentPlan: 'アサイン計画',
      actualStatus: {
        project: 'プロジェクト',
        role: '役割',
        planned: '予定(h)',
        actual: '実績(h)'
      },
      assignStatus: {
        project: 'プロジェクト',
        assignStart: 'アサイン開始',
        assignEnd: 'アサイン終了',
        status: 'ステータス',
        plannedEffort: '計画工数(h)',
        actualEffort: '実績工数(h)',
        statusPlanned: '予定',
        statusInProgress: '進行中',
        statusCompleted: '終了'
      }
    },
    employment: {
      create: '契約を作成',
      edit: '契約を変更',
      startMonth: '開始月',
      amount: '金額',
      costType: '単価タイプ',
      defaultCostStartMonthUnchangeable: 'デフォルトの単価の開始月は変更できません',
      currency: '円'
    },
    volumedAssign: {
      undefinedResourceEffortTotal: '未定要員の工数合計'
    },
    assignedJobtitle: {
      undefined: '未定',
      addAssignment: '[+割当]',
      department: '部署',
      skill: 'スキル'
    },
    tooltip: {
      projectName: 'プロジェクト名',
      projectCode: 'プロジェクトコード',
      period: '期間',
      role: '役割',
      clientName: 'クライアント名'
    },
    stageDeleteModal: {
      title: '変更内容を破棄',
      warning: '破棄した変更は元に戻せません',
      confirmation: '変更が全て破棄されます。よろしいですか？',
      discard: '破棄する'
    },
    userDetail: {
      title: '人材詳細',
      edit: '編集',
      email: 'メールアドレス',
      department: '部署',
      jobTitle: '役割',
      skill: 'スキル',
      assignStatus: 'アサイン状況',
      assignedProjects: 'アサインプロジェクト',
      projectSearchPlaceholder: 'プロジェクト名 / プロジェクトコード / クライアント名',
      projectName: 'プロジェクト名',
      projectCode: 'プロジェクトコード',
      period: '期間',
      client: 'クライアント'
    },
    jobResults: {
      loading: '読み込み中...',
      started: '開始',
      ended: '終了',
      executionLog: '実行ログ'
    }
  },
  login: {
    email: 'メールアドレス',
    password: 'パスワード',
    loginButton: 'ログイン',
    forgotPassword: 'パスワードをお忘れですか？',
    smallDeviceMessage: '画面の小さなデバイスでは稼働管理機能のみ対応しております。',
    mfaCodeInput: 'セキュリティコードを入力',
    mfaCodeDescription: 'Authenticatorアプリに表示される6桁のコードを入力してください',
    mfaSubmit: '認証',
    accountConnected: 'お使いのアカウントは、{{provider}} と連携されています。',
    loginWith: '{{provider}} を利用してログイン',
    or: 'または',
    mfaRegistrationTitle: '2要素認証の設定',
    mfaStep1Description:
      'お手元のスマートフォンに以下のAuthenticatorアプリをインストールしてください。',
    mfaStep2Description: '以下のQRコードをAuthenticatorアプリで読み込んでください。',
    mfaStep3Description: 'Authenticatorアプリに表示された6桁のコードを入力してください。',
    mfaSecretCodeLabel: 'シークレットコード:',
    mfaRetryLink: 'ログイン画面からやり直す',
    invalidCredentials: 'メールアドレスまたはパスワードが正しくありません。',
    tooManyRequests: '試行回数が多すぎます。しばらく経ってからお試しください。',
    userDisabled: 'このユーザーは無効化されています。管理者にお問い合わせください。',
    defaultErrorMessage: 'ログインに失敗しました。',
    invalidMfaCode: '認証コードが間違っています。再度お試しください。',
    timeoutError: 'タイムアウトエラー。再度ログイン画面からお試しください。'
  },
  forgetPassword: {
    title: 'パスワード再設定URLを送信します。',
    description: '登録しているメールアドレスを入力してください。',
    email: 'メールアドレス',
    sendButton: 'メールを送信',
    backToLogin: 'ログイン画面に戻る',
    successMessage: 'パスワード再設定用のURLが記載されたメールを送信しました。',
    emailError: '正しいメールアドレスを入力してください',
    accountNotFound: 'アカウントが見つかりません。',
    systemError: 'システムエラーが発生しました。時間をおいてお試しください。'
  },
  notFound: {
    title: 'ページが見つかりません',
    titleShort: '404 Not Found',
    message: 'お探しのページは見つかりませんでした',
    description: 'URLが間違っているか、ページが移動または削除された可能性があります。',
    support: '引き続き問題が発生する場合は、管理者にお問い合わせください。',
    homeButton: '今すぐホームに戻る',
    genericError: 'エラー'
  },
  validation: {
    REQUIRED: '必須',
    INVALID_DATE: '日付の形式が正しくありません。',
    INVALID_ALPHANUMERIC: '半角英数記号で入力してください',
    END_DATE_AFTER_START_DATE: '終了日は開始日よりも未来にしてください。',
    WITHIN_5_YEARS: '開始日から終了日までの期間は5年以内にしてください。',
    WORK_RESULT_OUTSIDE_PERIOD: '期間外に実績（稼働またはその他費用）が登録されています。',
    CODE_EXISTS: 'そのコードはすでに使われています',
    MAX_30_ITEMS: '30個以下にしてください',
    MAX_30_USERS: '30人以下にしてください',
    MAX_10_DEPARTMENTS: '10部署以下にしてください',
    attendance: {
      lessThan3600: '35:59までしか入力できません',
      startBeforeEnd: '開始時刻は終了時刻より前の時間にしてください',
      withinWorkingHours: '勤務時間内で入力してください',
      overlapBreak: '休憩時間が重複しています'
    }
  }
} as const

type Message = typeof jaMessages
// objectのvalueをstring literalからstringに緩めるヘルパー型関数
type MessageValues<T> = {
  [K in keyof T]: T[K] extends object ? MessageValues<T[K]> : string
}

export type MessageStruct = MessageValues<Message>
